import * as Actions from '../actions/loadCountries.actions'

const initialState = {
  countryList: [],
}

export default function (state = initialState, action) {
  const newState = { ...state }
  switch (action.type) {
    case Actions.GET_COUNTRIES_SUCCESS: {
      return {
        ...newState,
        countryList: [...action.data],
      }
    }
    default: {
      return newState
    }
  }
}
